import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { Unstable_Grid2 as Grid } from '@mui/material';
import SelectFieldAdapter from 'components/shared/field-adapters/SelectFieldAdapter';
import TypeaheadFieldAdapter from 'components/shared/field-adapters/TypeaheadFieldAdapter';
import FilterButtons from 'components/shared/buttons/FilterButtons';
import { getGenderOptions, getTrashedOptions } from 'common/constants/options';
import requestStatus from 'common/constants/status';
import StyledFiltersContainer from 'common/theme/filters/StyledFiltersContainer';
import StyledFiltersForm from 'common/theme/filters/StyledFiltersForm';
import { handleSupervisorIdChange } from 'common/utils/user';
import useForms from 'hooks/useForms';
import supervisorSlice from 'store/modules/supervisor';

function SupervisorFilters() {
  const dispatch = useDispatch();
  const { t } = useTranslation(['labels']);
  const { clearSupervisorSearchResults } = useForms;

  const supervisorOptions = useSelector((state) => state.supervisor.searchResults);
  const initialValues = useSelector((state) => state.supervisor.filters);
  const searchStatus = useSelector((state) => state.supervisor.status.search);
  const status = useSelector((state) => state.supervisor.status.general);

  const onSupervisorIdChange = handleSupervisorIdChange(dispatch);

  const onFilter = useCallback(
    (values) => {
      dispatch(supervisorSlice.actions.updateFilters(values));
    },
    [dispatch]
  );

  const resetForm = useCallback(() => {
    dispatch(supervisorSlice.actions.resetFilters());
  }, [dispatch]);

  return (
    <StyledFiltersContainer>
      <Form
        initialValues={initialValues}
        onSubmit={onFilter}
        render={({ handleSubmit, pristine }) => (
          <StyledFiltersForm onSubmit={handleSubmit}>
            <Grid container spacing={{ xs: 2, lg: 4 }}>
              <Grid xs={12}>
                <Field
                  id="user_id"
                  name="user_id"
                  component={TypeaheadFieldAdapter}
                  fullWidth
                  loading={searchStatus === requestStatus.loading}
                  isMultiple
                  onInputChange={onSupervisorIdChange}
                  options={supervisorOptions}
                  onClose={clearSupervisorSearchResults}
                  renderInputProps={{
                    label: t('supervisor', { count: 2, ns: 'labels' })
                  }}
                />
              </Grid>
              <Grid xs={12} sm={6}>
                <Field
                  id="gender"
                  name="gender"
                  component={SelectFieldAdapter}
                  options={getGenderOptions(t)}
                  label={t('gender', { ns: 'labels' })}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} sm={6}>
                <Field
                  id="soft_delete"
                  name="soft_delete"
                  component={SelectFieldAdapter}
                  options={getTrashedOptions(t)}
                  label={t('deleted', { ns: 'labels' })}
                  fullWidth
                />
              </Grid>
            </Grid>
            <FilterButtons pristine={pristine} resetForm={resetForm} status={status} />
          </StyledFiltersForm>
        )}
      />
    </StyledFiltersContainer>
  );
}

export default SupervisorFilters;
